module.exports = __webpack_public_path__ + "static/img/act-tj.a91559cb.png";